module.exports = __webpack_public_path__ + "static/media/video_thumb1.378b0a05.png";